import { gql } from 'graphql-request';

export const UPDATE_PRESCRIPTION_MUTATION = gql`
      mutation updatePrescriptionDetails($input:UpdatePrescriptionInput!) {
        updatePrescriptionDetails(input:$input) {
          message
          id
        }
      }
    `;
